import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AnniversaryTextSection from '../components/AnniversaryTextSection';
import AnniversarySection from '../components/AnniversarySection';
import ConfidenceSection from '../components/ConfidenceSection';
import PhoneSection from '../components/PhoneSection';
import RiskFreeSection from '../components/RiskFreeSection';
import ConfidentTradingSection from '../components/ConfidentTradingSection';
import WithdrawalSection from '../components/WithdrawalSection';
import SmoothTradingSection from '../components/SmoothTradingSection';
import CommunitiesSection from '../components/CommunitiesSection';
import AwardsSection from '../components/AwardsSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <HeroSection />
      <AnniversarySection />
      <AnniversaryTextSection />
      <PhoneSection />
      <RiskFreeSection />
      <ConfidentTradingSection />
      <WithdrawalSection />
      <SmoothTradingSection />
      <CommunitiesSection />
      <AwardsSection />
      <ConfidenceSection />
      <Footer />
    </div>
  );
};

export default HomePage;
